import { isDevelopmentMode, methods, sendRequest } from "../base";

export const getUserInfo = () => {
  return sendRequest(
    isDevelopmentMode() ? "/accounts/profile" : "/users/user_data/me/"
  );
};
export const validateInviteCode = (inviteCode) => {
  return sendRequest(
    isDevelopmentMode()
      ? "/accounts/validate-invited-code"
      : "/users/user_data/me/",
    methods.POST,
    { invited_code: inviteCode }
  );
};
export const updateUserInfo = (
  first_name = null,
  last_name = null,
  mobile_number = null,
  email = null,
  national_code = null,
  birth_date = null,
  validationResult = {}
) => {
  const formData = new FormData();
  if (first_name && !validationResult.first_name) {
    formData.append("first_name", first_name);
  }
  if (last_name && !validationResult.last_name) {
    formData.append("last_name", last_name);
  }
  if (mobile_number && !validationResult.mobile_number) {
    formData.append("mobile_number", mobile_number);
  }
  if (email) {
    formData.append("email", email);
  }
  if (national_code && !validationResult.national_code) {
    formData.append("national_code", national_code);
  }
  if (birth_date && !validationResult.birth_date) {
    formData.append("birth_date", birth_date);
  }
  return sendRequest(
    isDevelopmentMode() ? "/accounts/profile" : "/users/user_data/me/",
    methods.PUT,
    formData
  );
};
